import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import TenantDashboardComponent from '../components/tenant/dashboard';

interface User {
  id: string;
  email: string;
  isAdmin: boolean;
  approved: boolean;
  createdAt: string;
  updatedAt: string;
}

const TenantDashboard: React.FC = () => {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('token');
    const userStr = localStorage.getItem('user');

    if (!token || !userStr) {
      navigate('/login');
      return;
    }

    try {
      const userData = JSON.parse(userStr);
      if (userData.isAdmin) {
        navigate('/admin/dashboard');
        return;
      }
      setUser(userData);
    } catch (err) {
      navigate('/login');
    } finally {
      setLoading(false);
    }
  }, [navigate]);

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    navigate('/login');
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-main-dark flex items-center justify-center">
        <div className="text-gray-400 text-lg">Loading...</div>
      </div>
    );
  }

  return (
    <div className="w-full min-h-screen bg-main-dark flex flex-col">
      <Header
        title="Tenant Dashboard"
        subtitle={user ? `Welcome, ${user.email}` : undefined}
        onLogout={handleLogout}
        onSettingsClick={() => navigate('/settings')}
      >
        {!user?.approved && (
          <div className="mt-2 p-2 bg-yellow-900/30 border border-yellow-500/50 rounded text-yellow-200 text-xs">
            Your account is pending approval. Please wait for admin approval.
          </div>
        )}
      </Header>
      <TenantDashboardComponent user={user || undefined} />
      <Footer />
    </div>
  );
};

export default TenantDashboard;
